import { Preferences } from '@capacitor/preferences';

// 存储工具类
class StorageUtil {
  // 检查是否在Capacitor环境中
  static isCapacitor() {
    try {
      // 优先检查 window.Capacitor
      if (typeof window !== 'undefined' && window.Capacitor) {
        return true;
      }
      
      // 额外检查：检查 navigator.userAgent 是否包含 Capacitor 或 Android
      if (typeof navigator !== 'undefined' && navigator.userAgent) {
        const userAgent = navigator.userAgent.toLowerCase();
        return userAgent.includes('capacitor') || userAgent.includes('android');
      }
      
      return false;
    } catch (error) {
      console.error('检查Capacitor环境失败:', error);
      return false;
    }
  }

  // 设置存储
  static async setItem(key, value) {
    try {
      const stringValue = typeof value === 'string' ? value : JSON.stringify(value);
      
      // 同时更新 localStorage，确保同步场景中可以获取到数据
      if (typeof localStorage !== 'undefined') {
        try {
          localStorage.setItem(key, stringValue);
        } catch (e) {
          console.error('localStorage存储失败:', e);
        }
      }
      
      // 在Capacitor环境中使用Preferences
      if (this.isCapacitor()) {
        await Preferences.set({
          key,
          value: stringValue
        });
      }
      
      return true;
    } catch (error) {
      console.error('存储数据失败:', error);
      return false;
    }
  }

  // 获取存储（异步方法）
  static async getItem(key) {
    try {
      if (this.isCapacitor()) {
        // 在Capacitor环境中使用Preferences
        const result = await Preferences.get({ key });
        if (result.value) {
          // 尝试解析JSON，失败则返回原始字符串
          try {
            return JSON.parse(result.value);
          } catch {
            return result.value;
          }
        }
        return null;
      } else {
        // 在Web环境中使用localStorage
        const value = localStorage.getItem(key);
        if (value) {
          // 尝试解析JSON，失败则返回原始字符串
          try {
            return JSON.parse(value);
          } catch {
            return value;
          }
        }
        return null;
      }
    } catch (error) {
      console.error('获取数据失败:', error);
      return null;
    }
  }

  // 获取存储（同步方法，用于axios拦截器等同步场景）
  static getItemSync(key) {
    try {
      // 无论是否在Capacitor环境中，都尝试使用localStorage作为首选
      if (typeof localStorage !== 'undefined') {
        const value = localStorage.getItem(key);
        if (value) {
          // 尝试解析JSON，失败则返回原始字符串
          try {
            return JSON.parse(value);
          } catch {
            return value;
          }
        }
      }
      
      // 如果localStorage不可用，再检查是否在Capacitor环境中
      // 在Capacitor环境中，由于Preferences是异步的，这里返回null
      // 实际使用中，应该在应用启动时预加载token到内存
      return null;
    } catch (error) {
      console.error('同步获取数据失败:', error);
      return null;
    }
  }

  // 删除存储
  static async removeItem(key) {
    try {
      if (this.isCapacitor()) {
        // 在Capacitor环境中使用Preferences
        await Preferences.remove({ key });
      } else {
        // 在Web环境中使用localStorage
        localStorage.removeItem(key);
      }
      return true;
    } catch (error) {
      console.error('删除数据失败:', error);
      return false;
    }
  }

  // 清空存储
  static async clear() {
    try {
      if (this.isCapacitor()) {
        // 在Capacitor环境中使用Preferences
        await Preferences.clear();
      } else {
        // 在Web环境中使用localStorage
        localStorage.clear();
      }
      return true;
    } catch (error) {
      console.error('清空数据失败:', error);
      return false;
    }
  }
}

export default StorageUtil;